import React from 'react'
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

interface Props {
    editor: any;
    snackbarOpen: boolean;
    snackbarMessage: string;
    toggleSnackbarOpen: () => void;
}

const EditorActionAlert = (props: Props) => {
    const {snackbarOpen, snackbarMessage, editor} = props;
    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={() => props.toggleSnackbarOpen()}
            ContentProps={{
                "aria-describedby": "message-id",
            }}
            message={<span id="message-id">{snackbarMessage}</span>}
            action={[
                <span key="0" style={{ marginTop: "5px" }}>
                    {
                        snackbarMessage.includes("paste") && (
                        <Button
                            color="inherit"
                            onClick={() => {
                                editor.execute("undo");
                                props.toggleSnackbarOpen();
                            }}
                        >
                            UNDO
                        </Button>
                    )}
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => props.toggleSnackbarOpen()}
                    >
                        <CloseIcon />
                    </IconButton>
                </span>
            ]}
        />
    );
}

export default EditorActionAlert

